import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { addYears } from "date-fns";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PpsUtilityService } from "../services/pps-utility.service";
import { TicketStatus } from "../shared/models/roster/ticket-status";
import { IUpdateTravelStatusModel } from "../shared/models/roster/update-travel-status-model";

@Component({
  selector: "pps-update-travel-status-form",
  templateUrl: "./update-travel-status-form.component.html"
})
export class UpdateTravelStatusFormComponent implements OnInit{
  private initialValues = {
    presetDateRange: "today",
    fromDate: this._util.getDateOnly(new Date()),
    toDate: this._util.getDateOnly(new Date())
  };

  travelStatuses: any = [
    {id: TicketStatus.Approved, name: "Approved"},
    {id: TicketStatus.PendingApproval, name: "Pending approval"},
    {id: TicketStatus.Planned, name: "Planned"}];  

  updateTravelStatusModel: IUpdateTravelStatusModel = {
    travelStatus: null,
    dateRange: {}
  };

  message = "";
  yearRange: string = "";

  public dateRanges: {id:string, title: string}[] = [];
  public selectedDateRange: {id:string, title: string} = null;

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dlgConfig: DynamicDialogConfig,
    private _util: PpsUtilityService) {
    this.setData(this._dlgConfig.data);
  }

  ngOnInit(): void {
    let dateRanges = this._util.getDateRanges();
    this.dateRanges = Object.keys(dateRanges).map(key => { return {id: key, title: dateRanges[key].title}; });
    this.yearRange = `2018:${addYears(new Date(), 5).getFullYear()}`;

    this.initialize();
  }

  onDateRangeChanged(event){
    this.setDateRange();
  }

  private setData(data: any){
    if (!data){
      return;
    }
    
    this.initialValues = Object.assign(this.initialValues, data.initialValues);
  }

  private initialize(){
    if (this.initialValues.presetDateRange){
      let ranges = this.dateRanges.filter(dt => dt.title.toLowerCase() === this.initialValues.presetDateRange?.toLowerCase());
      if (ranges.length > 0){
        this.selectedDateRange = ranges.length > 0 ? ranges[0] : null;  
      }
    }

    this.setDateRange();
  }

  private setDateRange(){
    if (this.selectedDateRange){
      let range = this._util.getDateRange(this.selectedDateRange.id);
      if (range){
        this.updateTravelStatusModel.dateRange.from = range.from;
        this.updateTravelStatusModel.dateRange.to = range.to;
      }
    }else{
      this.updateTravelStatusModel.dateRange.from = this.initialValues.fromDate;
      this.updateTravelStatusModel.dateRange.to = this.initialValues.toDate;
    }
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    if (this.updateTravelStatusModel.dateRange.from > this.updateTravelStatusModel.dateRange.to){
      this.message = "From date must be earlier than To date";
      return;
    }

    if (this.updateTravelStatusModel.travelStatus === null){
      this.message = "Please pick a travel status to updated to";
      return;
    }

    this._dialogRef.close(this.updateTravelStatusModel);
  }

  cancel(){
    this._dialogRef.close();
  }  
}